<div class="container mb-5">
  <div class="navbar-brand text-center p-0">
    <img [src]="'assets/logos/logo2.png'" [ngStyle]="{ width: namespace === 'onex-usa' ? '60px' : '120px' }" height="100%" class="d-inline-block align-top" alt="">
    <p class="m-0 p-0 bottom-center text-primary text-center smallHomeUrl">{{ url }}</p>
  </div>
</div>

<div class="container mb-5" style="margin-top: 35px">
  <p>{{"mobile-app.intro" | translate: {program: productName} }}</p>
  <p *ngIf="this.referredCodeParam">{{"mobile-app.step-1" | translate: {program: productName, code: referredCodeParam} }}</p>
  <p *ngIf="!this.referredCodeParam">{{"mobile-app.step-1_1" | translate: {program: productName} }}</p>
  <div class="col-12" style="display: flex; flex-direction: row;">
    <div class="col-sm-3 col-md-3 col-lg-2">
      <a target="_blank" class="text-center" [href]="androidStoreURL">
        <img src="/assets/images/store_android.png" class="img-fluid" alt="android">
      </a>
    </div>
    <div class="col-sm-3 col-md-3 col-lg-2 mb-3">
      <a target="_blank" class="text-center" [href]="iosStoreURL">
        <img src="/assets/images/store_ios.png" class="img-fluid" alt="ios">
      </a>
    </div>
  </div>
  <p>{{"mobile-app.end" | translate: {program: productName} }}</p>
</div>